const signIn = {
  "signin.not.a.member.ingress": "¿No eres miembro?",
  "signin.not.a.member.link": "Regístrate",
  "signin.sign.up": "Regístrate",
  "signin.sign.in": "Iniciar sesión",
  "signin.welcome": "Eleva tu juego. Alcanza tu mejor versión.",
  "signin.email.label": "Correo electrónico",
  "signin.email.placeholder": "tucorreo@ejemplo.com",
  "signin.email.invalid": "Por favor ingresa una dirección de correo válida",
  "signin.password.label": "Contraseña",
  "signin.password.placeholder": "Ingresa tu contraseña",
  "signin.sign.in.button": "Iniciar sesión",
  "signin.forgot.password.ingress": "¿Olvidaste tu contraseña?",
  "signin.forgot.password.link": "Restablecer contraseña",
  "signin.password.reset.sent": "Se ha enviado un enlace para restablecer la contraseña. Revisa tu correo para continuar.",
};

const forgotPassword = {
  "forgot.password.title": "Olvidé mi contraseña",
  "forgot.password.ingress": "Ingresa el correo electrónico que usaste al registrarte y te enviaremos instrucciones para restablecer tu contraseña.",
  "forgot.password.email.label": "Correo electrónico",
  "forgot.password.email.placeholder": "Tu dirección de correo",
  "forgot.password.send.button": "Enviar instrucciones",
  "forgot.password.success.title": "Instrucciones para restablecer enviadas",
  "forgot.password.success.message":
    "Te hemos enviado un correo con instrucciones para restablecer tu contraseña. Revisa tu correo y sigue el enlace para continuar.",
};

const signUp = {
  "signup.join.us": "Únete a nosotros",
  "signup.sign.up": "Regístrate en Be Your Best",
  "signup.personal.details": "Datos personales",
  "signup.security.details": "Detalles de seguridad",
  "signup.first.label": "Nombre",
  "signup.first.placeholder": "Nombre",
  "signup.last.label": "Apellido",
  "signup.last.placeholder": "Apellido",
  "signup.email.label": "Correo electrónico",
  "signup.email.placeholder": "tucorreo@ejemplo.com",
  "signup.password.label": "Contraseña",
  "signup.password.placeholder": "8+ caracteres",
  "signup.confirm.password.label": "Confirmar contraseña",
  "signup.confirm.password.placeholder": "Confirmar contraseña",
  "signup.sign.up.button": "Continuar",
  "signup.already.a.member.ingress": "¿Ya eres miembro?",
  "signup.already.a.member.link": "Inicia sesión",
  "signup.password.reset.sent": "Se ha enviado un enlace para restablecer la contraseña. Revisa tu correo para continuar.",
  "signup.accept-terms.label": "Al registrarte en Be Your Best, acepto sus {{terms}} y {{privacy}}.",
  "signup.accept-terms.terms.link.label": "Términos de servicio",
  "signup.accept-terms.privacy.link.label": "Política de privacidad",
  "signup.accept-terms.terms.link.href.default": "https://www.beyourbest.com/terms",
  "signup.accept-terms.terms.link.href.demo": "https://www.beyourbest.com/be-your-best-trial-terms-conditions",
  "signup.accept-terms.privacy.link.href": "https://www.beyourbest.com/privacy",
  "signup.title.default": "Regístrate en Be Your Best",
  "signup.title.demo": "Comienza tu Prueba de 2 Días",
  "signup.subtitle.default": "Eleva tu juego. Logra tu mejor versión.",
  "signup.subtitle.demo": "Experimenta Be Your Best con acceso limitado por 2 días.",
  "signup.button.default": "Continuar",
  "signup.button.demo": "Comenzar Prueba Gratuita",
  "signup.full.version.ingress": "¿Quieres la versión completa?",
  "signup.full.version.link": "Regístrate aquí",
  "signup.verify.title.default": "Bienvenido a Be Your Best",
  "signup.verify.title.demo": "Verifica tu Cuenta de Prueba",
  "signup.verify.subtitle.default": "Estás creando una cuenta para {{email}}",
  "signup.verify.subtitle.demo": "¡Casi listo! Solo verifica tu correo para comenzar tu prueba de 2 días.",
  "signup.verify.description.default":
    "Te hemos enviado un correo para verificar tu cuenta. Revisa tu bandeja de entrada y haz clic en el enlace de verificación.",
  "signup.verify.description.demo":
    "Te hemos enviado un correo de verificación. Por favor revisa tu bandeja de entrada y haz clic en el enlace para activar tu cuenta de prueba.",
  "signup.verify.refresh.default": "Actualizar cuenta",
  "signup.verify.refresh.demo": "He verificado mi correo",
  "signup.verify.resend.default": "Reenviar correo",
  "signup.verify.resend.demo": "Reenviar correo de verificación",
  "signup.verify.signout.default": "Cerrar sesión",
  "signup.verify.signout.demo": "Cerrar sesión",
};

const utils = {
  "utils.password.no.match": "Las contraseñas no coinciden",
  "utils.password.min.length": "La contraseña debe tener al menos 8 caracteres",
};

const paymentProductSelectionDialog = {
  "payment.product.selection.dialog.title.personal": "Personal",
  "payment.product.selection.dialog.title.business": "Empresarial",
  "payment.product.selection.dialog.description.personal":
    "Para personas que desean mejorar su rendimiento con herramientas y análisis personalizados",
  "payment.product.selection.dialog.description.business": "Para organizaciones y equipos que buscan soluciones personalizadas",
  "payment.product.selection.dialog.price.unit-per-interval": "{{ currency }} / mes",
  "payment.product.selection.dialog.included-quantity": "{{ quantity }} plazas incluidas",
  "payment.product.selection.dialog.billed.year": "{{ price }} facturado anualmente",
  "payment.product.selection.dialog.billed.month": "{{ price }} facturado mensualmente",
};

const checkout = {
  "checkout.payment.billing-address-incomplete": "Introduce tu dirección de facturación completa.",
  "checkout.payment.currency-updating": "Los clientes de Noruega deben pagar en NOK. Espera a que se actualicen los precios.",
  "checkout.subscription.promo.exlusive.error.gca": "Este código promocional solo se puede aplicar a una membresía anual.",
  "checkout.payment.heading": "Pago",
  "checkout.payment.billing-address": "Dirección de facturación",
  "checkout.payment.payment-details": "Datos de pago",
  "checkout.payment.body.1": "Completa los datos de tu tarjeta y empieza hoy mismo.",
  "checkout.payment.body.2.1": "Consulta nuestros",
  "checkout.payment.body.2.2": "dispositivos VR compatibles.",
  "checkout.payment.card.error": "Ocurrió un error inesperado. Por favor contacta con soporte.",
  "checkout.payment.currency-unavailable":
    "Los precios en NOK no están disponibles actualmente. Por favor contacta con soporte para completar tu compra.",
  "checkout.payment.powered.by": "Desarrollado por",
  "checkout.payment.provider": "Stripe",
  "checkout.payment.pay": "Pagar {{ price }}",
  "checkout.payment.creating_confirmation_token": "Generando token de confirmación",
  "checkout.payment.creating_subscription": "Creando suscripción",
  "checkout.payment.finalizing_account": "Finalizando cuenta",
  "checkout.payment.ending_demo_account": "Finalizando cuenta de prueba",
  "checkout.error.unexpected": "Ocurrió un error inesperado. Por favor recarga la página o contacta soporte.",
  "checkout.error.promo.code.invalid.generic": "Código promocional inválido",
  "checkout.error.promo.code.invalid.subscription": "El código promocional {{promoCode}} no es válido para la suscripción seleccionada",
  "checkout.error.demo-account-ended-failed.title": "Error al finalizar tu cuenta de prueba",
  "checkout.error.demo-account-ended-failed.message": "Error al finalizar tu cuenta de prueba. Por favor contacta soporte.",
  "payment.outstanding.invoice.dialog.title": "Factura pendiente",
  "payment.outstanding.invoice.dialog.description.default":
    "Tienes una factura pendiente de una anterior compra que necesita ser pagada antes de poder acceder al producto.",
  "payment.outstanding.invoice.dialog.description.checkout":
    "Parece que ya has intentado comprar una suscripción, pero el pago falló. Por favor paga la factura pendiente para continuar.",
  "payment.outstanding.invoice.dialog.amount.label": "Cantidad pendiente",
  "payment.outstanding.invoice.dialog.instructions":
    "Haz clic en el botón a continuación para abrir la página de pago en una nueva pestaña. Después de completar tu pago, recarga esta página y podrás acceder al producto.",
  "payment.outstanding.invoice.dialog.button.pay": "Pagar factura",
  "payment.outstanding.invoice.dialog.button.cancel": "Cancelar",
  "payment.outstanding.invoice.banner.title": "Factura pendiente",
  "payment.outstanding.invoice.banner.description": "Tienes una factura pendiente de {{amount}} de una compra anterior.",
  "payment.outstanding.invoice.banner.button.refresh": "Recargar página",
  "payment.outstanding.invoice.banner.button.pay": "Ver",
};

const updatePlan = {
  "update.plan.payment.method.card": "{{brand}} •••• {{last4}}",
  "update.plan.payment.method.card.expires": "Vence {{month}}/{{year}}",
  "update.plan.payment.method.link": "Stripe Link",
  "update.plan.payment.method.sepa": "Débito SEPA •••• {{last4}}",
  "update.plan.payment.method.bank": "Cuenta bancaria •••• {{last4}}",
  "update.plan.payment.method.unknown": "Método de pago desconocido",
};

const general = {
  "components.sign.out.button": "Cerrar sesión",
  "components.back.button": "Atrás",
};

const imageSection = {
  "image.section.martin.odegaard.quote":
    "Muy divertido, pero un trabajo duro. Sin carga física. Gracias Be Your Best por ayudarme a entrenar mi visión y toma de decisiones durante mi período de lesión.",
  "image.section.martin.odegaard.source.text": "Martin Ødegaard",
  "image.section.martin.odegaard.source.subtext": "Arsenal",
  "image.section.martin.odegaard.source.caption": "vía Instagram",

  "image.section.scan.rate.title": "28",
  "image.section.scan.rate.postfix": "%",
  "image.section.scan.rate.body":
    "El aumento promedio en la frecuencia de escaneo después de 9 semanas usando Be Your Best. Esto a menudo resulta en un mayor número de pases exitosos hacia adelante, y beneficia el control de la posesión, las oportunidades de gol y la flexibilidad táctica.",

  "image.section.companion.app.title": "App complementaria",
  "image.section.companion.app.body":
    "Sigue tu progreso, compite en clasificaciones y domina tus habilidades. Nuestra app complementaria ofrece análisis completos e información útil para ayudarte a mejorar tu juego y tus habilidades cognitivas.",

  "image.section.ben.osborn.quote":
    "Relacionar cuántas veces escanea un jugador con sus pases exitosos hacia adelante está muy bien. Realmente lo disfruté.",
  "image.section.ben.osborn.source.text": "Ben Osborn",
  "image.section.ben.osborn.source.subtext": "Sheffield United",
};

const survey = {
  "survey.help_us.title": "Ayúdanos a mejorar",
  "survey.help_us.description": "¿Dónde escuchaste sobre Be Your Best? Puedes seleccionar más de una opción.",
  "survey.help_us.friends": "Amigos / Familia",
  "survey.help_us.news": "Leí sobre ustedes",
  "survey.help_us.other": "Otro",
  "survey.help_us.instagram": "Instagram",
  "survey.help_us.tiktok": "TikTok",
  "survey.help_us.youtube": "YouTube",
  "survey.help_us.facebook": "Facebook",
  "survey.skip": "Omitir",
};

const demoDiscontinued = {
  "demo.discontinued.title": "Prueba Ya No Disponible",
  "demo.discontinued.description":
    "Agradecemos tu interés en Be Your Best. Aunque nuestro programa de prueba ya no está disponible, nos encantaría que te unas a nuestra comunidad con una membresía completa.",
  "demo.discontinued.already.member.ingress": "¿Ya tienes una cuenta?",
  "demo.discontinued.already.member.link": "Inicia sesión",
  "demo.discontinued.not.member.ingress": "¿Listo para empezar?",
  "demo.discontinued.not.member.link": "Regístrate para acceso completo",
};

const subscriptionPanel = {
  "subscription.menu.item.save.percent": "Ahorras {{ percent }}%",
  "payment.subscription.panel.title.subscription": "Suscripción",
  "payment.subscription.panel.button.view.details": "Ver detalles",
  "payment.subscription.panel.label.promo.code": "Código promocional",
  "payment.subscription.panel.placeholder.promo.code": "Agregar código promocional",
  "payment.subscription.panel.button.apply": "Aplicar",
  "payment.subscription.panel.button.remove": "Eliminar",
  "payment.subscription.panel.label.extra.seats": "Agregar plazas extra",
  "payment.subscription.panel.subscription.label": "Suscripción {{title}}",
  "payment.subscription.panel.text.monthly.breakdown": "{{price}} por mes",
  "payment.subscription.panel.discount.duration.once": "solo en el primer pago",
  "payment.subscription.panel.discount.duration.repeating": "por tiempo limitado",
  "payment.subscription.panel.discount.duration.forever": "durante toda la suscripción",
  "payment.subscription.panel.discount.tooltip": "Este descuento se aplica {{duration}}",
  "payment.subscription.panel.discount.savings": "Ahorras {{amount}} por pago",
  "payment.subscription.panel.discount.description": "{{amount}} de descuento {{duration}}",
  "payment.subscription.panel.discount.applied": "Código promocional {{code}} aplicado",
  "payment.subscription.panel.discount.amount": "${{amount}} de descuento",
  "payment.subscription.panel.discount.percent": "{{percent}}% de descuento",
  "payment.subscription.panel.email.mismatch.title": "Has iniciado sesión con otro correo",
  "payment.subscription.panel.email.mismatch.message":
    "Has iniciado sesión como {{currentEmail}}, pero este enlace de pago se abrió para {{linkEmail}}.",
  "payment.subscription.panel.button.continue.as": "Continuar como {{email}}",
  "payment.subscription.panel.label.logged.in.email": "Sesión iniciada como",
  "payment.subscription.panel.renewal.info":
    "Tu suscripción {{intervalText}} se renovará el {{renewalDate}}. El pago de {{price}} cubrirá tu plan de {{quantity}} {{seats}}.",
  "payment.subscription.panel.text.seat": "plaza",
  "payment.subscription.panel.text.seats": "plazas",
  "payment.subscription.panel.text.interval.annual": "anual",
  "payment.subscription.panel.text.interval.monthly": "mensual",
  "payment.subscription.panel.price.per.month": "{{price}} / mes",
};

export const purchaseFlow = {
  ...checkout,
  ...forgotPassword,
  ...general,
  ...imageSection,
  ...signIn,
  ...signUp,
  ...utils,
  ...updatePlan,
  ...paymentProductSelectionDialog,
  ...subscriptionPanel,
  ...survey,
  ...demoDiscontinued,
};
